import { AutocompleteOption, ProjectAutocompleteOption } from './autocompleteOption';
import { Project } from './project';
import { Task } from './task';

export enum ProfilePreferencesField {
  VIEW_MODE = 'activityView',
  PROJECT = 'project',
  TASK = 'task',
  EXPORT_SHOW_CONTRACT_TYPE = 'exportDetailsShowContractType',
  EXPORT_SHOW_PROJECT_MANAGER = 'exportDetailsShowProjectManager',
}

export interface ProfilePreferences {
  [ProfilePreferencesField.VIEW_MODE]: number;
  [ProfilePreferencesField.PROJECT]: ProjectAutocompleteOption | null;
  [ProfilePreferencesField.TASK]: Task | null;
  [ProfilePreferencesField.EXPORT_SHOW_CONTRACT_TYPE]: boolean;
  [ProfilePreferencesField.EXPORT_SHOW_PROJECT_MANAGER]: boolean;
}

export interface ProfilePreferencesResponse {
  defaultProjectId: string | null;
  defaultTaskId: string | null;
  activityView: number;
  exportDetailsShowContractType: boolean;
  exportDetailsShowProjectManager: boolean;
}

export enum ViewMode {
  DAY = 'Day',
  WEEK = 'Week',
  WORK_WEEK = 'Work week',
  MONTH = 'Month',
  OLD_VIEW = 'List view',
}

export const PREFERENCES = [
  ViewMode.DAY,
  ViewMode.WORK_WEEK,
  ViewMode.WEEK,
  ViewMode.MONTH,
  ViewMode.OLD_VIEW,
];
